import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=2dc31aea&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc31aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc31aea')) {
      api.createRecord('2dc31aea', component.options)
    } else {
      api.reload('2dc31aea', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=2dc31aea&scoped=true&", function () {
      api.rerender('2dc31aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25pId3rCF4LEt/JS/comp/Voucher.vue"
export default component.exports